import { EventsCollectionQueryModel } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';
import { AppState } from 'src/AppState/AppState';
import { action, computed, makeAutoObservable } from 'mobx';
import { AvailableItemType } from 'src/components/Filters/FilterTabs';
import { DateTime } from 'src_common/utils/time/time';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { QUICKPICK_ROUTER_NAMESPACE } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/QuickPickView.state';

export class DayFilterState {
    public timezone = 'Europe/London';

    public constructor(
        readonly getEvents: () => EventsCollectionQueryModel | null,
        private readonly appState: AppState
    ) {
        makeAutoObservable(this);
    }

    @action public onSetTimeFilter = (time: string): void => {
        this.appState.routerBackoffice.setParamInNamespace(QUICKPICK_ROUTER_NAMESPACE, 'time-filter', time);
    };

    @computed public get availableTimeFilters(): Array<AvailableItemType> {
        const availableDays: Array<AvailableItemType> = [];
        const events = this.getEvents()?.events;

        if (events === undefined) {
            return availableDays;
        }

        availableDays.push(
            ...availableDays.concat(
                this.hasEventsPerDay(events, 0) === true
                    ? [
                          {
                              id: DateTime.current().format('dddd'),
                              name: 'Today',
                          },
                      ]
                    : [],
                this.hasEventsPerDay(events, 1) === true
                    ? [
                          {
                              id: DateTime.current().addDays(1).format('dddd'),
                              name: 'Tomorrow',
                          },
                      ]
                    : [],
                this.hasEventsPerDay(events, 2) === true
                    ? [
                          {
                              id: DateTime.current().addDays(2).format('dddd'),
                              name: DateTime.current().addDays(2).format('dddd'),
                          },
                      ]
                    : [],
                this.hasEventsPerDay(events, 3) === true
                    ? [
                          {
                              id: DateTime.current().addDays(3).format('dddd'),
                              name: DateTime.current().addDays(3).format('dddd'),
                          },
                      ]
                    : [],
                this.hasEventsPerDay(events, 4) === true
                    ? [
                          {
                              id: DateTime.current().addDays(4).format('dddd'),
                              name: DateTime.current().addDays(4).format('dddd'),
                          },
                      ]
                    : [],
                this.hasEventsPerDay(events, 5) === true
                    ? [
                          {
                              id: DateTime.current().addDays(5).format('dddd'),
                              name: DateTime.current().addDays(5).format('dddd'),
                          },
                      ]
                    : [],
                this.hasEventsPerDay(events, 6) === true
                    ? [
                          {
                              id: DateTime.current().addDays(6).format(),
                              name: DateTime.current().addDays(6).format(),
                          },
                      ]
                    : []
            )
        );

        return availableDays.length > 0 ? availableDays : [{ id: 'today', name: 'Today' }];
    }

    private hasEventsPerDay = (events: Array<EventListGroupEventItemType>, day: number): boolean => {
        return events.some((event) => DateTime.from(event.startTime)?.isSameDay(DateTime.current().addDays(day)));
    };

    private firstAvailableDayId = (): string => {
        return this.availableTimeFilters[0]?.id ?? 'today';
    };

    @computed public get currentTimeFilter(): string {
        return (
            this.appState.routerBackoffice.getParametersString(QUICKPICK_ROUTER_NAMESPACE, 'time-filter') ??
            this.firstAvailableDayId()
        );
    }

    @computed public get eventsFromCurrentTimeFilter(): EventsCollectionQueryModel | null {
        const events = this.getEvents();

        if (events === null) {
            return null;
        }

        const currentFilter = this.currentTimeFilter;

        return events.filter((event) => {
            const eventStartTimeDayName = DateTime.from(event.startTime)?.format('dddd');

            return eventStartTimeDayName?.toLowerCase() === currentFilter.toLowerCase();
        });
    }
}
